import React from 'react';

export const ListGray600Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.2222 2.7H15.3333V1H13.5556V2.7H6.44444V1H4.66667V2.7H3.77778C2.8 2.7 2 3.465 2 4.4V16.3C2 16.7509 2.1873 17.1833 2.5207 17.5021C2.8541 17.8209 3.30628 18 3.77778 18H16.2222C17.2089 18 18 17.2435 18 16.3V4.4C18 3.94913 17.8127 3.51673 17.4793 3.19792C17.1459 2.87911 16.6937 2.7 16.2222 2.7ZM16.2222 16.3H3.77778V7.8H16.2222V16.3ZM3.77778 6.1V4.4H16.2222V6.1H3.77778ZM5.55556 9.5H14.4444V11.2H5.55556V9.5ZM5.55556 12.9H11.7778V14.6H5.55556V12.9Z"
        fill="#333333"
      />
    </svg>
  );
};
